import { render, staticRenderFns } from "./module-configuration.vue?vue&type=template&id=4e41f15f&"
import script from "./module-configuration.vue?vue&type=script&lang=js&"
export * from "./module-configuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports